import Container from 'typedi';
import SpotRepository from '../repositories/SpotRepository';
class SpotService {
  spotRepository;
  constructor() {
    this.spotRepository = Container.get(SpotRepository);
  }
  getSpots = async () => await this.spotRepository.getSpots();
}

Container.set({ id: SpotService, type: SpotService });

export default SpotService;
